<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'App',
  metaInfo() {
    return {
      title: '企业应用及银行直连平台',
      titleTemplate: title => {
        return title
      }
    }
  },
  computed: {
    ...mapGetters([
      'language'
    ]),
  },
  watch: {
    language: function (val, oldVal) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style>
body{
  margin: 0px;
  padding: 0px;
}
html {
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue